// src/store/analyticsStories/action-types.ts
export const VIEW_STORY_G = 'VIEW_STORY';
export const CREATE_STORY_VIEW_G = 'CREATE_STORY_VIEW_G';
export const CREATE_STORY_ACTION_G = 'CREATE_STORY_ACTION_G';
export const UPDATE_STORY_VIEW_G = 'UPDATE_STORY_VIEW_G';
export const UPDATE_STORY_ACTION_G = 'UPDATE_STORY_ACTION_G';
export const DELETE_STORY_VIEW_G = 'DELETE_STORY_VIEW_G';
export const DELETE_STORY_ACTION_G = 'DELETE_STORY_ACTION_G';
export const FILTER_STORY_ACTION_G = 'FILTER_STORY_ACTION_G';

export const CREATE_MEMORY_VIEW_G = 'CREATE_MEMORY_VIEW_G';
export const CREATE_MEMORY_ACTION_G = 'CREATE_MEMORY_ACTION_G';
export const UPDATE_MEMORY_VIEW_G = 'UPDATE_MEMORY_VIEW_G';
export const UPDATE_MEMORY_ACTION_G = 'UPDATE_MEMORY_ACTION_G';
export const DELETE_MEMORY_VIEW_G = 'DELETE_MEMORY_VIEW_G';
export const DELETE_MEMORY_ACTION_G = 'DELETE_MEMORY_ACTION_G';
export const VIEW_MEMORY_G = 'VIEW_MEMORY_G';
